import { useEffect, memo } from "react";
import { CheckCircle2, AlertCircle } from "lucide-react";

export interface ToastProps {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
}

const Toast = memo(({ message, type, onClose }: ToastProps) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);
  return (
    <>
      <div className={`toast ${type}`}>
        {type === 'success' ? <CheckCircle2 size={20} /> : <AlertCircle size={20} />}
        <span>{message}</span>
      </div>
      <style>{`
        .toast {
          position: fixed;
          right: 32px;
          bottom: 32px;
          min-width: 240px;
          max-width: 320px;
          background: #fff;
          color: #222;
          border-radius: 10px;
          box-shadow: 0 4px 24px rgba(0,0,0,0.13);
          padding: 16px 22px;
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 1rem;
          font-weight: 500;
          z-index: 999999;
          animation: toastIn 0.3s cubic-bezier(.4,2,.6,1);
        }
        .toast.success { border-left: 5px solid #22c55e; }
        .toast.error { border-left: 5px solid #ef4444; }
        @keyframes toastIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
});

export default Toast; 